<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import AdvancedHorizontalBarChart from "@/components/app/charts/AdvancedHorizontalBarChart.vue";

const props = defineProps({
  height: {
    type: Number,
    default: 150,
  },
  sourceData: {
    type: Object,
    required: true,
  },
});

const chartData = computed(() => {
  return {
    labels: ["Verdeling"],
    datasets: [
      {
        label: "Reeds uitgevoerd",
        data: [],
        sumData: [],
        backgroundColor: "#00A2DF",
      },
      {
        label: "Nog uit te voeren",
        data: [],
        sumData: [],
        backgroundColor: "steelblue",
      },
      {
        label: "Niet van toepassing",
        data: [],
        sumData: [],
        backgroundColor: "grey",
      },
    ],
  };
});
const options = ref({
  //todo fix scales
  // scales: {
  //   yAxes: [
  //     {
  //       display: false,
  //       stacked: true,
  //     },
  //   ],
  //   xAxes: [
  //     {
  //       stacked: true,
  //       ticks: {
  //         minx: 0,
  //         max: 100,
  //       },
  //     },
  //   ],
  // },
  legend: {
    display: true,
  },
  plugins: {
    tooltip: {
      mode: "index",
      intersect: false
    },
  },
});

const chartStyle = computed(() => {
  return {
    width: "100%",
    height: `${props.height}px`,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
  };
});

watch(
  () => props.sourceData,
  () => {
    chartData.value.datasets[0].data = [props.sourceData.prcExecuted];
    chartData.value.datasets[0].sumData = [props.sourceData.numExecuted];
    chartData.value.datasets[1].data = [props.sourceData.prcApplicable];
    chartData.value.datasets[1].sumData = [props.sourceData.numApplicable];
    chartData.value.datasets[2].data = [props.sourceData.prcNotRelevant];
    chartData.value.datasets[2].sumData = [props.sourceData.numNotRelevant];
  },
  { deep: true, immediate: true }
);
</script>

<template>
  <div class="vue-chart applied-measures">
    <advanced-horizontal-bar-chart :chartData="chartData" :options="options" :style="chartStyle"></advanced-horizontal-bar-chart>
  </div>
</template>
